import { Formik, Form as FormikForm } from 'formik';
import React, { useEffect } from 'react';
import { Col, Container, Form, Row, Spinner } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import Select from 'react-select';
import Input from '../../../Components/Input/Input';
import ajclWhiteLogo from "../../../images/ajcl_logo_white.png";
import { signUpUser } from '../../../Redux/Action/Auth';
import { getDepartments } from "../../../Redux/Action/Dashboard";
import { departmentStyles, getUserDetail } from '../../../Utils/Helper';
import { errorNotify, successNotify } from '../../../Utils/Toast';
import { signUpSchema } from '../../../Utils/Validations';

const SignUp = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { loading, signUpApiData, error } = useSelector((state) => state.signUpAuth);
  const { loading: departmentLoading, getDepartmentsData } = useSelector((state) => state.departmentsGet)

  useEffect(() => {
    const token = localStorage.getItem('tmsToken');
    if (token) {
      if (getUserDetail()?.role === 'user') {
        navigate('/dashboard/interested-tenders');
      }
      else {
        navigate('/dashboard');
      }
    }
  }, [navigate]);

  useEffect(() => {
    dispatch(getDepartments());
  }, []);

  useEffect(() => {
    if (signUpApiData?.statusCode === 200) {
      navigate('/');
      successNotify("Registration Successful!");
      dispatch({ type: "SIGNUP_RESET" });
    }
    else if (error) {
      errorNotify(error);
      dispatch({ type: "SIGNUP_RESET" });
    }
  }, [signUpApiData, error]);

  const initialValues = {
    email: '',
    user_name: '',
    password: '',
    confirm_password: '',
    department_id: '',
  };

  const departOptions = getDepartmentsData?.data?.length > 0 ? getDepartmentsData?.data?.map((d) => {
    return {
      value: d?.id, label: d.name
    }
  }) : []

  return (
    <div className='login_wrapper'>
      <Container fluid>
        <Row>
          <Col md={6} className='login_left_side'>
            <div>
              <img src={ajclWhiteLogo} alt="logo" className='main_logo' />
              <h1>Tender Management System</h1>
            </div>
          </Col>
          <Col md={6} className='login_right_side'>
            <div className='login_form_wrapper signup_wrapper'>
              <div className='login_form_heading'>
                <h2>Create Account</h2>
                <p>Please fill in the details below</p>
              </div>
              <Formik
                initialValues={initialValues}
                validationSchema={signUpSchema}
                onSubmit={(values) => {
                  const formData = new FormData();
                  formData.append('email', values.email);
                  formData.append('user_name', values.user_name);
                  formData.append('password', values.password);
                  formData.append('confirm_password', values.confirm_password);
                  formData.append('department_id', values.department_id);

                  dispatch(signUpUser(formData));
                }}
              >
                {({ setFieldValue, errors, touched }) => (
                  <FormikForm>
                    <Row>
                      <Col md={6}>
                        <Input
                          type="text"
                          name="user_name"
                          label="Full Name"
                          placeholder="Enter full name"
                        />
                      </Col>
                      <Col md={6}>
                        <Input
                          type="email"
                          name="email"
                          label="Email"
                          placeholder="Enter email"
                        />
                      </Col>
                      <Col md={6}>
                        <Input
                          type="password"
                          name="password"
                          label="Password"
                          placeholder="Enter password"
                        />
                      </Col>
                      <Col md={6}>
                        <Input
                          type="password"
                          name="confirm_password"
                          label="Confirm Password"
                          placeholder="Confirm password"
                        />
                      </Col>
                      <Col md={12}>
                        <Form.Group>
                          <Form.Label>Department</Form.Label>
                          <Select
                            options={departOptions}
                            onChange={(selected) => setFieldValue('department_id', selected.value)}
                            isLoading={departmentLoading}
                            styles={departmentStyles}
                          />
                          {touched.department_id && errors.department_id && (
                            <div className="error-message">{errors.department_id}</div>
                          )}
                        </Form.Group>
                      </Col>
                    </Row>

                    <button type="submit" className='login_btn mt-3' disabled={loading}>
                      {loading ? <Spinner animation='border' size='sm' /> : 'Sign Up'}
                    </button>

                    <div className='auth_links mt-3'>
                      <p>Already have an account? <Link to="/">Login</Link></p>
                    </div>
                  </FormikForm>
                )}
              </Formik>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default SignUp;